import { createSlice } from '@reduxjs/toolkit';
const SETTINGS_KEY = 'boushar.counters.settings';
const loadSettings = () => {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (stored != undefined) {
        try {
            return JSON.parse(stored);
        }
        catch (error) {
            console.error('Failed to parse counters settings from localStorage:', error);
        }
    }
    return { showResetButton: true }; // Default: show button
};
const saveSettings = (state) => {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(state));
};
const initialState = loadSettings();
const countersSettingsSlice = createSlice({
    name: 'countersSettings',
    initialState,
    reducers: {
        toggleShowResetButton: (state) => {
            state.showResetButton = !state.showResetButton;
            saveSettings(state);
            return state;
        }
    }
});
export const { toggleShowResetButton } = countersSettingsSlice.actions;
export default countersSettingsSlice;
